import { render, staticRenderFns } from "./ValidateRequesterComponent.vue?vue&type=template&id=cb81625c&scoped=true&"
import script from "./ValidateRequesterComponent.vue?vue&type=script&lang=js&"
export * from "./ValidateRequesterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb81625c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItem})
